/* LH | Second item via the TeeInBlue cross-sell, as one compact card (Leon, 24.10.2026, socks).
 * Config and texts: snippets/lh-cross-sell-config.liquid (metaobject lh_cross_sell).
 *
 * - TeeInBlue renders its cross-sell block (.tee-cross-sell-product-button); the snippet hides it. This script
 *   puts our card ([data-lh-pair]) right after it and drives the TeeInBlue block: the button "Paar
 *   personalisieren" or the card opens TeeInBlue's personalization popup.
 *   Once added: the button gives way to a pill "Bearbeiten" (TeeInBlue's edit button) and "Entfernen". Remove clicks
 *   TeeInBlue's clear button and confirms its dialog at once, the dialog stays invisible (Leon: no popup).
 * - State comes from TeeInBlue: the class tee-cross-sell-product-button--has-product means the second item is
 *   in the form and goes into the cart with the main product.
 * - Order in the panel: TeeInBlue block, our card, gift box, print file check, buttons. The gift box anchors
 *   itself above the print file check (lh-bag-upsell.js), so we only keep the print file check below our card.
 * - Price: shown = price minus discount_pct, struck through = compare-at price. While the second item is in the
 *   form we tell assets/lh-cross-sell-cart.js, which puts the hidden code into the cart before add to cart, so
 *   the cart drawer opens with the right price.
 */
(function () {
  if (window.__lhPairLoaded) return;
  window.__lhPairLoaded = true;

  var cfg = null;
  try { cfg = JSON.parse(document.getElementById('lh-cross-sell-pair-config').textContent); } catch (e) { return; }

  function money(cents) {
    var fmt = cfg.moneyFormat || '{{amount_with_comma_separator}}€';
    function num(n, d, t, dec) {
      var parts = (Number(n) / 100).toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts[0] + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return num(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(cents, 2, "'", '.');
        case 'amount_with_space_separator': return num(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return num(cents, 0, ' ', ',');
        case 'amount_with_period_and_space_separator': return num(cents, 2, ' ', '.');
        default: return num(cents, 2, ',', '.');
      }
    });
  }

  function tee() { return document.querySelector('.tee-cross-sell-product-button'); }
  function added() { var t = tee(); return !!(t && t.classList.contains('tee-cross-sell-product-button--has-product')); }

  function variantPrices() {
    var input = document.querySelector('form[data-type="add-to-cart-form"] .product-variant-id') || document.querySelector('.product-variant-id');
    var id = (input && input.value) || new URLSearchParams(location.search).get('variant') || '';
    var p = cfg.prices[id];
    if (!p) { var keys = Object.keys(cfg.prices); p = keys.length ? cfg.prices[keys[0]] : [0, 0]; }
    return p;
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  var PEN = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>';
  var BIN = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/></svg>';

  function build() {
    var root = el('div', 'lh-cs');
    root.setAttribute('data-lh-pair', '');
    var media = el('div', 'lh-cs__media');
    var thumb = el('div', 'lh-cs__thumb');
    if (cfg.img) { var img = el('img'); img.src = cfg.img; img.alt = ''; img.width = 84; img.height = 84; thumb.appendChild(img); }
    media.appendChild(thumb);
    if (cfg.badge) media.appendChild(el('span', 'lh-cs__badge', ''));
    var plus = el('span', 'lh-cs__plus', '+');
    plus.setAttribute('aria-hidden', 'true');
    media.appendChild(plus);
    root.appendChild(media);
    var t = el('div', 'lh-cs__t');
    t.appendChild(el('span', 'lh-cs__title', cfg.title));
    t.appendChild(el('p', 'lh-cs__note', cfg.note));
    var pp = el('div', 'lh-cs__pp');
    pp.appendChild(el('span', 'lh-cs__price', ''));
    pp.appendChild(el('s', '', ''));
    t.appendChild(pp);
    root.appendChild(t);
    // right side (Leon, 24.10.2026, canvas variant C): "Paar personalisieren" until added, then a pill "Bearbeiten"
    // with a pen and below it "Entfernen" with a bin, in the place of the button.
    var acts = el('div', 'lh-cs__acts');
    var cta = el('button', 'lh-cs__cta', cfg.cta || cfg.title);
    cta.type = 'button';
    cta.setAttribute('data-lh-pair-cta', '');
    acts.appendChild(cta);
    var edit = el('button', 'lh-cs__edit');
    edit.type = 'button';
    edit.hidden = true;
    edit.setAttribute('data-lh-pair-edit', '');
    edit.innerHTML = PEN;
    edit.appendChild(document.createTextNode(cfg.edit || ''));
    acts.appendChild(edit);
    if (cfg.remove) {
      var rm = el('button', 'lh-cs__remove');
      rm.type = 'button';
      rm.hidden = true;
      rm.setAttribute('data-lh-pair-remove', '');
      rm.innerHTML = BIN;
      rm.appendChild(document.createTextNode(cfg.remove));
      acts.appendChild(rm);
    }
    root.appendChild(acts);
    return root;
  }

  var block = null;
  var sig = '';
  var wasOn = null;
  function sync() {
    popupPrice();
    var t = tee();
    if (!t) { if (block) block.hidden = true; return; }
    if (!block) block = build();
    block.hidden = false;
    if (t.nextElementSibling !== block) t.insertAdjacentElement('afterend', block);
    // print file check below our card; the gift box anchors itself right above the print file check
    var dc = document.querySelector('.ck-datacheck--injected');
    if (dc && dc.parentElement === block.parentElement && (block.compareDocumentPosition(dc) & Node.DOCUMENT_POSITION_PRECEDING)) {
      block.insertAdjacentElement('afterend', dc);
    }
    var on = added();
    if (on !== wasOn) {
      // also on load when TeeInBlue restores a saved second item into the form (QA 24.10.2026)
      if ((wasOn !== null || on) && cfg.code && typeof window.lhCrossSellPending === 'function') window.lhCrossSellPending(cfg.code, on);
      wasOn = on;
    }
    var p = variantPrices();
    var s = (on ? 1 : 0) + '|' + p.join(',');
    if (s === sig) return;
    sig = s;
    block.classList.toggle('lh-cs--on', on);
    block.querySelector('[data-lh-pair-cta]').hidden = on;
    block.querySelector('.lh-cs__plus').textContent = on ? '\u2713' : '+';
    block.querySelector('.lh-cs__note').textContent = on && cfg.done ? cfg.done : cfg.note;
    block.querySelector('[data-lh-pair-edit]').hidden = !on;
    var rmBtn = block.querySelector('[data-lh-pair-remove]');
    if (rmBtn) rmBtn.hidden = !on;
    block.querySelector('.lh-cs__price').textContent = money(p[0]);
    block.querySelector('.lh-cs__pp s').textContent = p[1] > p[0] ? money(p[1]) : '';
    // badge = saving against the struck price, so it matches what the customer sees (16,95 vs 22,95 = -26 %)
    var badge = block.querySelector('.lh-cs__badge');
    if (badge) badge.textContent = p[1] > p[0] ? cfg.badge.replace('{p}', String(Math.round((p[1] - p[0]) / p[1] * 100))) : '';
    if (badge) badge.hidden = !badge.textContent;
  }

  // Popup price: TeeInBlue's popup shows the variant at full price with "Spare 3,00 €". We leave its (Vue) nodes alone,
  // hide them and show our copy: second pair price, struck compare-at price, saving in percent like the main product.
  // The hidden TeeInBlue price keeps updating with the size, we look its variant up by that price.
  function popupPrice() {
    var orig = document.querySelector('.tee-cross-sell-product-popup .tee-cross-sell-product__price:not([data-lh-cs-pp])');
    if (!orig) return;
    var cur = orig.querySelector('.tee-price--current');
    var shown = cur ? cur.textContent.trim() : '';
    var p = null;
    Object.keys(cfg.prices).some(function (id) { var x = cfg.prices[id]; if (money(x[2]) === shown) { p = x; return true; } return false; });
    var copy = orig.parentElement.querySelector('[data-lh-cs-pp]');
    if (!p) { orig.classList.remove('lh-cs-hidden'); if (copy) copy.remove(); return; }
    var pct = p[1] > p[0] ? Math.round((p[1] - p[0]) / p[1] * 100) : 0;
    var key = p.join(',');
    if (copy && copy.getAttribute('data-lh-cs-pp') === key && orig.classList.contains('lh-cs-hidden')) return;
    if (!copy) {
      copy = orig.cloneNode(true);
      copy.classList.remove('lh-cs-hidden');
      orig.insertAdjacentElement('afterend', copy);
    }
    copy.setAttribute('data-lh-cs-pp', key);
    var c = copy.querySelector('.tee-price--current');
    if (c) c.textContent = money(p[0]);
    var was = copy.querySelector('.tee-price--compare:not(.tee-price--saving *)');
    if (was) was.textContent = money(p[1]);
    var sav = copy.querySelector('.tee-price--saving .money');
    var savBox = copy.querySelector('.tee-price--saving-wrapper');
    if (sav) sav.textContent = pct + '%';
    if (savBox) savBox.style.display = pct ? '' : 'none';
    orig.classList.add('lh-cs-hidden');
  }

  function teeClick(selector) {
    var t = tee();
    if (!t) return;
    var target = selector ? t.querySelector(selector) : t;
    (target || t).click();
  }

  // Remove at once: click TeeInBlue's clear button, then its "yes" in the confirm dialog (hidden by CSS meanwhile).
  function removePair() {
    var html = document.documentElement;
    html.classList.add('lh-cs-rm');
    teeClick('.tee-cross-sell-product-preview__clear');
    var tries = 0;
    // keep the dialog invisible until TeeInBlue has taken it out of the page (it fades out for 0.4 s)
    function release(n) {
      if (document.querySelector('.tee-confirm-delete-addon-product-popup') && n < 40) { setTimeout(function () { release(n + 1); }, 50); return; }
      html.classList.remove('lh-cs-rm');
    }
    (function confirm() {
      var yes = document.querySelector('.tee-confirm-delete-addon-product-popup .tee-btn--confirm-yes');
      if (yes) { yes.click(); release(0); return; }
      if (++tries < 40) setTimeout(confirm, 50);
      else html.classList.remove('lh-cs-rm');
    })();
  }

  // Edit refill (Agent QA 28.10.2026, bears DE + FR): when the second item is the same product, TeeInBlue's edit popup
  // fills its form from the main item's saved form (localStorage teeinblue-customizations is kept per product), so
  // "Bearbeiten" showed the first family's names and saving after one change overwrote the other names of the second
  // family. The second item's own data sits in that entry under customization.teeAddonProduct.customizationData and
  // is also kept here when the customer clicks "Fertig". On "Bearbeiten" we put it back into the popup's text fields
  // (input events, so TeeInBlue's form and preview take it) until the popup stands or the customer types.
  var savedPair = null;
  function popup() { return document.querySelector('.tee-cross-sell-product-popup'); }
  function popupTexts() {
    var p = popup();
    return p ? Array.prototype.filter.call(p.querySelectorAll('.tee-field input[type="text"][name]'), function (i) { return i.offsetParent; }) : [];
  }
  function storedPair() {
    try {
      var pid = String((window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.id) || '');
      var list = JSON.parse(localStorage.getItem('teeinblue-customizations') || '[]') || [];
      var e = list.find(function (x) { return x && x.customization && x.customization.teeAddonProduct && (!pid || String(x.productId) === pid); });
      return e ? e.customization.teeAddonProduct.customizationData || null : null;
    } catch (err) { return null; }
  }
  document.addEventListener('click', function (ev) {
    var p = popup();
    if (!p || !p.contains(ev.target) || !ev.target.closest('.tee-btn--atc, .tee-cross-sell-product__action button')) return;
    var data = {};
    popupTexts().forEach(function (i) { data[i.name] = i.value; });
    if (Object.keys(data).length) savedPair = data;
  }, true);
  function refillEdit() {
    var data = savedPair || storedPair();
    if (!data) return;
    var typed = false, tries = 0;
    var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    function onType(e) { if (e.isTrusted) typed = true; }
    document.addEventListener('input', onType, true);
    (function fill() {
      var ins = popupTexts();
      ins.forEach(function (i) {
        if (!Object.prototype.hasOwnProperty.call(data, i.name) || i.value === data[i.name]) return;
        setter.call(i, data[i.name]);
        i.dispatchEvent(new Event('input', { bubbles: true }));
        i.dispatchEvent(new Event('change', { bubbles: true }));
      });
      // keep at it while TeeInBlue builds the form (variant switch re-renders the fields), about 3 s
      if (!typed && ++tries < 15) setTimeout(fill, 200);
      else document.removeEventListener('input', onType, true);
    })();
  }

  document.addEventListener('click', function (ev) {
    if (!block || !block.contains(ev.target)) return;
    ev.preventDefault();
    if (ev.target.closest('[data-lh-pair-remove]')) { removePair(); return; }
    if (ev.target.closest('[data-lh-pair-edit]')) { teeClick('.tee-cross-sell-product-preview__edit'); refillEdit(); return; }
    // Button or card: opens TeeInBlue's personalization; once added, only the links act.
    if (!added()) teeClick(null);
  });

  document.addEventListener('change', function () { setTimeout(sync, 50); });

  function start() {
    sync();
    var busy = false;
    new MutationObserver(function () {
      if (busy) return;
      busy = true;
      setTimeout(function () { busy = false; sync(); }, 30);
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
